<template>
    <div class="teams-grouped__by-adv">
        <ds-table :data="groupingTeams" :heads="heads" expand :paginate="false" :max-items="groupingTeams.length">
            <template v-slot:name="{name}">
                <div class="flex items-center">
                    <div class="ml-1 mr-4 team_id">{{ name.team.is_internal ? 1 : name.team.id }}</div>
                    <p class="product-name font-medium truncate">{{ name.team.name }}</p>
                </div>
            </template>

            <template v-slot:users_list="{users_list}">
                <vs-chip v-tooltip.left="users_list.usersList.join('<br>')">
                    <vs-avatar color="#f0f0f0" text-color="#175ea5" icon-pack="feather" icon="icon-users"/>
                    <span>{{ users_list.usersLength }}</span>
                </vs-chip>
            </template>

            <template v-slot:integrations="{integrations}">
                <vs-chip v-tooltip.left="integrations.integration_names.join('<br>')">
                    <vs-avatar color="#f0f0f0" text-color="#175ea5" icon-pack="feather"
                               icon="icon-git-branch"/>
                    <span>{{ integrations.integration_length }}</span>
                </vs-chip>
            </template>

            <template v-slot:is_internal_team="{is_internal_team}">
                <vs-icon v-if="is_internal_team.team.is_internal" color="green" icon-pack="feather" icon="icon-check">
                </vs-icon>
                <span v-else>-</span>
            </template>

            <template v-slot:active="{active}">
                <div>
                    <vs-switch
                        v-can="'settings_team.destroy'"
                        color="success"
                        v-model="active.team.is_active"
                        @click.prevent.stop="changeTeamStatus($event, active)"
                        icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-check"
                    />
                    <vs-switch v-can:show="'settings_team.destroy'" color="success"
                               v-model="active.team.is_active" disabled icon-pack="feather" vs-icon-off="icon-x"
                               vs-icon-on="icon-check"/>
                </div>
            </template>

            <template v-slot:actions="{actions}">
                <div class="flex items-center h-full">
                    <vs-button v-can="'settings_advertiser.create'"
                               @click.stop="createIntegration(actions)"
                               v-tooltip="i('buttons.Add_integration')" radius color="primary" type="flat"
                               icon-pack="feather" icon="icon-plus"></vs-button>
                    <vs-button v-can:show="'settings_advertiser.create'" disabled
                               v-tooltip="i('buttons.Add_integration')" radius color="primary" type="flat"
                               icon-pack="feather" icon="icon-plus"></vs-button>

                    <vs-button
                        v-can="'settings_team.update'"
                        @click.stop="editTeam(actions)"
                        radius
                        v-tooltip="i('modals.Edit_team')"
                        color="primary" type="flat" icon-pack="feather" icon="icon-edit-2"></vs-button>
                    <vs-button v-can:show="'settings_team.update'" disabled radius color="primary"
                               type="flat" icon-pack="feather" icon="icon-edit-2"></vs-button>
                </div>
            </template>

            <template v-if="checkPermission" v-slot:expand="{expand}">
                <team-details :team-id="expand.team.id" :details="expand.integrations" grouped-teams
                              class="team-details w-full"></team-details>
            </template>
        </ds-table>
    </div>
</template>
<script>
import TeamDetails from '@/views/settings/teams/TeamDetails.vue'
import i18n from '../../../../i18n/i18n'
import {mapGetters} from 'vuex'
import EventBus from '../../../../store/eventBus'
import ErrorHandler from '../../../../utils/errorHandler'
import store from '@/store/store'
import {sorting} from '@/utils/mixins'

export default {
    name: 'TeamsGroupedByAdvertiser',
    mixins: [sorting],
    data() {
        return {
            heads: [
                {name: 'global.Name', key: 'name', sortKey: 'name', value: 'name', display: true},
                {name: 'global.Users', key: 'users_list', sortKey: 'usersLength', value: 'users_list', display: true},
                {name: 'global.Integrations', key: 'integrations', sortKey: 'integration_length', value: 'integrations', display: true},
                {name: 'table.Is_internal_team', key: 'is_internal_team', sortKey: 'is_internal', value: 'is_internal_team', display: true},
                {name: 'global.Status', key: 'status', sortKey: 'is_active', value: 'active', display: true},
                {name: 'global.Actions', key: 'actions', value: 'actions', display: true},
            ],
            currentIndex: null,
            currentArrIndex: null,
            loadingEl: null,
            groupingTeams: []
        }
    },
    components: {
        TeamDetails
    },
    props: {
        detailsData: Object
    },

    computed: {
        ...mapGetters(['userPermissions'])
    },
    methods: {
        i(val) {
            return i18n.tc(val)
        },

        createIntegration(data){
            EventBus.$emit('emitPopupEvent', {type: 'createTeamIntegrationWhenGroupedTeam', name: this.i('buttons.Add_integration'), data:{id: data.team.id, defaultAdv: data.integrations[0].advertiser_id}, width: '750'})
        },

        editTeam(data){
            EventBus.$emit('emitPopupEvent', {type: 'editTeam', name: this.i('modals.Edit_team'), ids: {...data.team, groupedByAdvertisers: true}})
        },
        changeTeamStatus(e, tr) {
            e.preventDefault()
            this.currentIndex = tr.team.id
            this.loadingEl = e.target.parentNode
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: this.i('confirm.Confirm_action'),
                text: this.i(tr.team.is_active ? 'confirm.deactivateTeam' : 'confirm.activateTeam'),
                accept: this.confirmStatus,
                acceptText: this.i(tr.team.is_active ? 'buttons.Deactivate' : 'buttons.Activate'),
                cancelText: this.i('global.Cancel')
            })
        },
        confirmStatus() {
            this.$vs.loading({
                background: 'rgba(255,255,255,0.75)',
                color: 'primary',
                container: this.loadingEl,
                scale: +'0.45'
            })

            const dispatchPath = 'destroy',
                dispatchData = {
                    url: this.$url.settings_team.destroy,
                    mutation: 'CHANGE_TEAM_STATUS',
                    data: {
                        id: this.currentIndex
                    },
                    ids: {
                        id: this.currentIndex,
                        arrId: this.currentArrIndex
                    }
                }
            store.dispatch(dispatchPath, dispatchData)
                .then(() => {
                    EventBus.$emit('getGroupedTeamsByAdvertiser')
                    this.$vs.loading.close(this.loadingEl)
                    this.loadingEl = this.currentIndex = null

                }).catch(err => {
                new ErrorHandler(err).send
            })
        },
        checkPermission() {
            return !!store.getters.userPermissions.settings_advertiser
        },

        mutationListData(data) {
            const groupingTeams = []
            data.advertiser_integrations.forEach(integration => {
                integration.advertiser_team_integration.forEach(item => {
                    if (!groupingTeams.some(team => team.team.id === item.team_id)) {
                        const team = {
                            team: {...item.teams},
                            advertiser_id: this.detailsData.id,
                            integrations: [{
                                ...integration,
                                countries: item.countries,
                                offers_accepted: item.offers_accepted,
                                id: item.id,
                                advertiser_integration_team_payment: item.advertiser_integration_team_payment,
                                advertiser_integration_id: item.advertiser_integration_id,
                                is_active: item.is_active
                            }]
                        }
                        groupingTeams.push(team)
                    } else {
                        groupingTeams.find(team => team.team.id === item.team_id).integrations.push({
                            ...integration,
                            countries: item.countries,
                            offers_accepted: item.offers_accepted,
                            id: item.id,
                            advertiser_integration_team_payment: item.advertiser_integration_team_payment,
                            advertiser_integration_id: item.advertiser_integration_id,
                            is_active: item.is_active
                        })
                    }
                })
            })

            this.groupingTeams = groupingTeams

            this.groupingTeams.forEach(item => {
                const users = item.team.users.map(user => user.name)

                item.usersList = users
                item.usersLength = users.length
                item.integration_names = item.integrations.map(integration => integration.name)
                item.integration_length = item.integration_names.length
                item.name = item.team.name
                item.is_internal = item.team.is_internal
                item.is_active = item.team.is_active

                return item
            })
        }
    },
    mounted() {
        this.mutationListData(this.detailsData)
        EventBus.$on('updateTeams', data => {
            if (data && Array.isArray(data)) {
                const obj = data.find(item => item.id === this.detailsData.id)
                if (obj) this.mutationListData(obj)
            }
        })
    },

    beforeDestroy() {
        EventBus.$off('updateTeams')
    }
}
</script>

<style lang="scss">

.tr-expand td .content-tr-expand {
    padding: 5px;
    border: none;
}

.tr-expand td .content-tr-expand, .tr-expand td .tr-expand--close {
    display: block !important;
}

</style>
